import { Component, OnInit, HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-adfs-clients',
  templateUrl: './adfs-clients.component.html',
  styleUrls: ['./adfs-clients.component.scss']
})
export class AdfsClientsComponent implements OnInit {
  adfsClientId: any;
  adfsName: any;
  adfsContact: any;
  adfsClientIdUp: any;
  adfsClientIdPre:any;
  adfsNameUp: any;
  adfsContactUp: any;
  adfsDateUp: any;
  restrictedAccess: any;
  adfsWebservices:any;
  adfsList: any = [];
  adfsView: any = [];
  adfsId: any;
  deleteId: any;
  erroradfsClientId: boolean = false;
  erroradfsName: boolean = false;
  erroradfsContact: boolean = false;
  erroradfsNameUp: boolean = false;
  erroradfsClientIdLength: boolean = false;
  erroradfsNameLength: boolean = false;
  erroradfsContactLength: boolean = false;
  erroradfsNameUpLength: boolean = false;
  erroradfsContactUpLength: boolean = false;
  erroradfsClientIdUpLength: boolean = false;
  erroradfsClientIdUp: boolean = false;
  erroradfsClientIdUp1: boolean = false;
  erroradfsContactUp: boolean = false;
  noerrorinadd: boolean = false;
  noerrorinup: boolean = false;
  erroradfsClientId1: boolean = false;
  addadfserror: boolean = false;
  editadfserror: boolean = false;
  deleteadfserror: boolean = false;
  isBackToTopShowBtn: boolean = false;
  constructor(private service: ApifirstService, private modalService: NgbModal, private translate:TranslateService) { }


  ngOnInit(): void {
    this.service.getAdfsClient().subscribe((data) => {
      this.adfsList = data
    })
  }

  clearVariables() {

  }
  addAdfs(addadfsclient: any)
   {
    this.erroradfsClientId = false;
    this.erroradfsName = false;
    this.erroradfsContact = false;
    this.erroradfsClientId1 = false;
    this.erroradfsClientIdLength = false;
    this.erroradfsNameLength  = false;
    this.erroradfsContactLength  = false;
    this.adfsClientId="";
    this.adfsName="";
    this.adfsContact=""
    this.service.getAdfsClient().subscribe((data) => {
      this.adfsList = data
    })
    this.modalService.open(addadfsclient, { centered: true, backdrop: 'static' });}

    setsubmiteditadfsclientAdd(adfsClientAdd: any, adfsNameAdd: any,adfsContactAdd: any) {
      this.erroradfsClientId = false;
      this.erroradfsName = false;
      this.erroradfsContact = false;
      this.erroradfsClientIdLength = false;
      this.erroradfsNameLength  = false;
      this.erroradfsContactLength  = false;
      this.erroradfsClientId1 = false;
      if (adfsClientAdd == null || adfsClientAdd == undefined || adfsClientAdd == '' ||
        adfsClientAdd.length === 0) {
        this.erroradfsClientId = true;
      }
      else {
        this.erroradfsClientId = false;
      }
      if (adfsNameAdd == null || adfsNameAdd == undefined || adfsNameAdd == '' ||
        adfsNameAdd.length === 0) {
        this.erroradfsName = true;
      }
      else {
        this.erroradfsName = false;
      }
      if (adfsContactAdd == null || adfsContactAdd == undefined || adfsContactAdd == '' ||
        adfsContactAdd.length === 0) {
        this.erroradfsContact = true;
      }
      else {
        this.erroradfsContact = false;
      }
     
      for(let i of this.adfsList){
        if(i.clientID==adfsClientAdd){
        this.erroradfsClientId1 = true;
        break;
        }
        else
        this.erroradfsClientId1 = false;
  
      }
      if(adfsClientAdd.length>70){
        this.erroradfsClientIdLength = true;
      }
      else
      this.erroradfsClientIdLength = false;

      if(adfsNameAdd.length>70){
        this.erroradfsNameLength = true;
      }
      else
      this.erroradfsNameLength = false;

      if(adfsContactAdd.length>100){
        this.erroradfsContactLength = true
        
      }
      else
     this.erroradfsContactLength = false
    
      if (this.erroradfsClientId == false && this.erroradfsName == false &&
        this.erroradfsContact == false && this.erroradfsClientId1 == false && 
        this.erroradfsContactLength == false &&  this.erroradfsNameLength == false && this.erroradfsClientIdLength == false ) {
        this.noerrorinadd = true;

      }
      else {
        this.noerrorinadd = false;
      }
     
  
      let req = {
        "clientID": adfsClientAdd,
        "applicationName": adfsNameAdd,
        "contactInfo": adfsContactAdd,
        "restrictedAccess":false
       
      }
      if (this.noerrorinadd == true) {
        this.service.addAdfsClient(req).subscribe((data) => {
          this.addadfserror = false;
          this.service.getAdfsClient().subscribe((data) => {
            this.adfsList = data
          })
          this.modalService.dismissAll(true);
        }, (error) => {
          this.addadfserror = true;
        });
      }
    }
    editAdfs(id: any,  clientId: any,name: any, contact: any,restrictedAccess: any,lastUsed: any,editAdfsClient: any) {
      this.modalService.open(editAdfsClient, { centered: true, backdrop: 'static' });
      this.erroradfsNameUp = false;
      this.erroradfsClientIdUp = false;
      this.erroradfsContactUp = false;
      this.erroradfsClientIdUp1 = false;
      this.adfsId = id;
      this.adfsClientIdUp = clientId;
      this.adfsClientIdPre = clientId;
      this.adfsNameUp = name;
      this.adfsContactUp = contact;
      this.adfsDateUp=lastUsed
      this.restrictedAccess = restrictedAccess;
      this.adfsWebservices=""
      this.erroradfsClientIdUpLength = false;
      this.erroradfsNameUpLength  = false;
      this.erroradfsContactUpLength  = false;
      this.service.getAdfsClientView(id).subscribe((data) => {
        this.adfsWebservices = data.adfsWebservices;
       
      })
      if(this.adfsWebservices=="" || this.adfsWebservices==undefined || this.adfsWebservices==null){
        this.adfsWebservices=this.translate.instant('No webservices found')
      }
     
    }
    deleteAdfsClient(id: any, deletePopUpAdfsClient: any) {
      this.modalService.open(deletePopUpAdfsClient, { centered: true, backdrop: 'static' });
      this.deleteId = id;
    }
    deletePopcredentialadfsclient() {
      this.service.deleteAdfsClient(this.deleteId).subscribe((data) => {})
      this.service.getAdfsClient().subscribe((data) => {
        this.adfsList = data
      })
      this.loadPage()
    }
    loadPage()
    {
      this.service.getAdfsClient().subscribe((data) => {
        this.adfsList = data
      })
    }
    setsubmiteditadfsclientedit(adfsClientUp: any, adfsNameUp: any,
      adfsContactUp: any, restrictedAccess: any) {
      this.erroradfsNameUp = false;
      this.erroradfsClientIdUp = false;
      this.erroradfsContactUp = false;
      this.erroradfsClientIdUp1 = false;
      this.erroradfsClientIdUpLength = false;
      this.erroradfsNameUpLength  = false;
      this.erroradfsContactUpLength  = false;
     
      if (adfsNameUp == null || adfsNameUp == undefined || adfsNameUp == '' ||
        adfsNameUp.length === 0) {
        this.erroradfsNameUp = true;
      }
      else {
        this.erroradfsNameUp = false;
      }
      if (adfsClientUp == null || adfsClientUp == undefined || adfsClientUp == '' ||
      adfsClientUp.length === 0) {
        this.erroradfsClientIdUp = true;
      }
      else {
        this.erroradfsClientIdUp = false;
      }
      if(adfsClientUp.length>70){
        this.erroradfsClientIdUpLength = true;
      }
      else
      this.erroradfsClientIdUpLength = false;

      if(adfsNameUp.length>70){
        this.erroradfsNameUpLength = true;
      }
      else
      this.erroradfsNameUpLength = false;

      if(adfsContactUp.length>100){
        this.erroradfsContactUpLength = true
        
      }
      else
     this.erroradfsContactUpLength = false

      if (adfsContactUp == null || adfsContactUp == undefined || adfsContactUp == '' ||
      adfsContactUp.length === 0) {
      this.erroradfsContactUp = true;
    }
    else {
      this.erroradfsContactUp = false;
    }
    for(let i of this.adfsList){
      if(i.clientID==adfsClientUp && this.adfsClientIdPre!=adfsClientUp){
      this.erroradfsClientIdUp1 = true;
      break;
      }
      else
      this.erroradfsClientIdUp1 = false;

    }
     
      if (this.erroradfsNameUp == false && this.erroradfsClientIdUp == false &&  this.erroradfsClientIdUp1 == false && this.erroradfsContactUp==false) {
        this.noerrorinup = true;
      }
      else {
        this.noerrorinup = false;
      }
      let req = {
        "clientID": adfsClientUp,
        "applicationName": adfsNameUp,
        "contactInfo": adfsContactUp,
        "restrictedAccess": restrictedAccess,
       
      }
      if (this.noerrorinup == true) {
        this.service.editAdfsClient(this.adfsId, req).subscribe((data) => {
          this.editadfserror = false;
          this.service.getAdfsClient().subscribe((data) => {
            this.adfsList = data
          })
          this.modalService.dismissAll(true);
        }, (error) => {
          this.editadfserror = true;
        });
      }
    }


    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        this.isBackToTopShowBtn = true;
      } else {
        this.isBackToTopShowBtn = false;
      }
    }
    @HostListener('window:scroll', ['$event']) // for window scroll events
    onScroll(event: any) {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        this.isBackToTopShowBtn = true;
      } else {
        this.isBackToTopShowBtn = false;
      }
    }
  }
  
  
